// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rowButton: {
      marginTop: theme.spacing(3),
    },
  }),
);

export default useStyles;
